import React, { Component } from 'react'
import { IntlProvider, injectIntl } from 'react-intl'

const contactLink = (locale) => {
  switch (locale) {
    case 'zh':
      return 'https://mtxc.com.cn/cn/contact-us.html'
    default:
      return `https://www.mtxc.eu/${locale}/contact-us.html`
  }
}

class ServerError extends Component {
  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  render() {
    return (
      <div className="error-page">
        <h1>{this.t('Exception.ServerErrorTitle')}</h1>
        <p>{this.t('Exception.ServerErrorDescription')}</p>

        <div className="btn-group">
        <a href="/" className="btn btn-xs btn-dark-blue">{this.t('Exception.ReturnToHomepage')}</a>
        &nbsp;&nbsp;
        <a href={contactLink(this.props.locale)} className="btn btn-xs btn-default">{this.t('Exception.LetUsKnow')}</a>
        </div>
      </div>
    )
  }
}

export default injectIntl(ServerError)



// WEBPACK FOOTER //
// ./app/javascript/components/exception/server_error.js